import HttpService from './HttpService';

const SiteApi = HttpService('/api/sites/');
const VesselApi = HttpService('/api/vessels/');

export default {
  getSites(siteFilter) { // eslint-disable-line no-unused-vars
    const queryString = null;
    const apiAction = 'GetSites';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return SiteApi.get(fullUrl);
  },
  getSiteById(id) {
    const apiAction = 'GetSiteById';
    const fullUrl = `${apiAction}?${id}`;
    return SiteApi.get(fullUrl);
  },
  getVessels(vesselsFilter) { // eslint-disable-line no-unused-vars
    const queryString = `activeSiteId=${vesselsFilter.activeSiteId}`;
    const apiAction = 'GetVessels';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return VesselApi.get(fullUrl);
  },
};
